import { ExceptionOutlined, FileDoneOutlined } from '@ant-design/icons';

interface IOrderHasMainInvoiceIconProps {
  hasMainInvoice: boolean;
  isShow: boolean;
}

export const OrderHasMainInvoiceIcon: React.FC<IOrderHasMainInvoiceIconProps> = ({ hasMainInvoice, isShow }) => {
  if (hasMainInvoice) {
    return <FileDoneOutlined style={{ fontSize: '20px', color: '#8c8c8c' }} />;
  }
  if (isShow) {
    return <ExceptionOutlined style={{ fontSize: '20px', color: '#ff4d4f' }} />;
  }
  return null;
};
